import axios from "axios";
import { useEffect } from "react";

export const useClientConfig = (setDynamicConfig: any) => {
  let configData = localStorage.getItem("client_config") || {};
  // TODO: later change it to true when the flow is ready and tested in prod
  let useNewDSCRFlow = false;

  const getClientConfig = async (clientName: string) => {
    try {
      const envs = ["dev", "stage", "qa", "perf", "preprod", "uat"];
      const clientUrlParts: string[] = clientName.split(".");
      const isLocalHost: boolean = clientName.includes("localhost");

      let apiBaseUrl = "";
      if (isLocalHost) {
        apiBaseUrl = "-dev";
      } else if (envs.includes(clientUrlParts[0])) {
        apiBaseUrl = `-${clientUrlParts[0]}`;
      }

      const { data }: any = await axios.get(
        `https://api${apiBaseUrl}.toorakcapital.info/online-sizer/config/fetch/${clientName}`
      );

      if (!data) return;
      configData = data;
      setDynamicConfig((prev: any) => ({
        ...prev,
        ...data,
        useNewDSCRFlow,
        supportEmail: data.supportEmail ?? "tooraksupport@triconinfotech.com",
      }));
      localStorage.setItem("client_config", JSON.stringify(data));
    } catch (error) {
      console.error("Error fetching client config", error);
    }
  };

  useEffect(() => {
    const enteredUrl = window.location.href;
    const parsedUrl = new URL(enteredUrl);
    getClientConfig(parsedUrl.hostname.replace("www.", ""));
  }, [setDynamicConfig]);

  return configData;
};
